import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
// @material-ui/core components
import {
  DialogActions,
  Button,
  LinearProgress,
  TextField,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  InputAdornment,
  IconButton,
  FormHelperText,
  ExpansionPanel,
  ExpansionPanelSummary,
  Grid,
  ExpansionPanelDetails,
  Typography,
} from "@material-ui/core";
// @material-ui/styles
import EmailIcon from "@material-ui/icons/Email";
import PersonIcon from "@material-ui/icons/Person";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockIcon from "@material-ui/icons/Lock";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// core components
import { UsersRepository } from "../UsersRepository";
import { LOCALE } from "../../../../properties/Locale";
import EntityMetadata from "../../../../common/components/EntityMetadata";
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  triggerRerender,
} from "../../../../common/actions/CommonActions";
import { MunicipalitiesRepository } from "../../../configuration/municipalities/MunicipalitiesRepository";
import { SchoolsRepository } from "../../../configuration/schools/SchoolsRepository";
import { associateCreateUserForm } from "./Validations";

export default function AssociateFormComponent(props) {
  const [disabled, setDisabled] = useState(props.disabled);
  const [action] = useState(props.action);
  const [showPassword, setShowPassword] = useState(false);
  const [schools, setSchools] = useState();
  const [municipalities, setMunicipalities] = useState();
  const [redirectTo, setRedirectTo] = useState();
  const [data, setData] = useState();
  const [rerender, triggerRerenderLocal] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setData(props.data);
    MunicipalitiesRepository.fetchAllMunicipalities({
      page: 0,
      size: 100,
      orderBy: "name",
      orderDirection: "ASC",
    })
      .then((res) => {
        setMunicipalities(res.data);
        if (props.data?.teacher?.school?.municipality != null) {
          SchoolsRepository.fetchAllSchoolsByMunicipality({
            municipalityId: props.data.teacher.school.municipality.id,
          }).then((res) => {
            setSchools(res.data);
            triggerRerenderLocal(!rerender);
          });
        }
        triggerRerenderLocal(!rerender);
      })
      .catch((err) => {});
  }, []);

  const handleSubmit = () => {
    props.showLoadingBar();
    data.name = data.teacher.firstName + " " + data.teacher.lastName;
    if (props.form == "myProfile") {
      UsersRepository.updateMyProfile(data)
        .then((res) => {
          props.hideLoadingBar();
          dispatch(triggerRerender());
          dispatch(
            notifyShowSuccessMessage(LOCALE.user_update_success_message)
          );
          setRedirectTo("/app/profile");
        })
        .catch((err) => {
          props.hideLoadingBar();
          dispatch(notifyShowErrorMessage(err.message));
        });
    } else {
      if (action == "create") {
        props.showLoadingBar();
        UsersRepository.createUser(data)
          .then((res) => {
            props.hideLoadingBar();
            dispatch(triggerRerender());
            dispatch(
              notifyShowSuccessMessage(LOCALE.user_create_success_message)
            );
            setRedirectTo("/app/admin/users");
          })
          .catch((err) => {
            props.hideLoadingBar();
            if (err.response?.data?.message) {
              dispatch(notifyShowErrorMessage(err.response?.data?.message));
            } else {
              dispatch(notifyShowErrorMessage(err.message));
            }
          });
      } else {
        props.showLoadingBar();
        UsersRepository.updateUser(data)
          .then((res) => {
            props.hideLoadingBar();
            dispatch(triggerRerender());
            dispatch(
              notifyShowSuccessMessage(LOCALE.user_update_success_message)
            );
            setRedirectTo("/app/admin/users");
          })
          .catch((err) => {
            props.hideLoadingBar();
            dispatch(notifyShowErrorMessage(err.message));
          });
      }
    }
  };

  const setDataProp = (event, name) => {
    var dataProp = data;
    if (name === "municipality") {
      dataProp.teacher.school.municipality["id"] = event.target.value;
    } else if (name === "school") {
      dataProp.teacher.school["id"] = event.target.value;
    } else {
      dataProp[name] = event.target.value;
    }
    setData(dataProp);
    if (name === "municipality") {
      SchoolsRepository.fetchAllSchoolsByMunicipality({
        municipalityId: event.target.value,
      }).then((res) => {
        setSchools(res.data);
      });
    }
    triggerRerenderLocal(!rerender);
  };

  const setDataPropTeacher = (event, name) => {
    var dataProp = data;
    dataProp.teacher[name] = event.target.value;
    setData(dataProp);
    triggerRerenderLocal(!rerender);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const resetPassword = () => {
    UsersRepository.resetPassword(data)
      .then((res) => {
        props.hideLoadingBar();
        dispatch(triggerRerender());
        dispatch(notifyShowSuccessMessage(LOCALE.user_update_success_message));
        if (props.form == "myProfile") {
          setRedirectTo("/app/profile");
        } else {
          setRedirectTo("/app/admin/users");
        }
      })
      .catch((err) => {
        props.hideLoadingBar();
        dispatch(notifyShowErrorMessage(err.message));
      });
  };

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      <div>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          size="small"
          label={LOCALE.login_firstname}
          name="firstName"
          value={data?.teacher?.firstName}
          autoFocus
          onChange={(e) => setDataPropTeacher(e, "firstName")}
          InputProps={{
            disabled: disabled,
            startAdornment: (
              <InputAdornment position="start">
                <PersonIcon />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          size="small"
          label={LOCALE.login_lastname}
          name="lastName"
          value={data?.teacher?.lastName}
          onChange={(e) => setDataPropTeacher(e, "lastName")}
          InputProps={{
            disabled: disabled,
            startAdornment: (
              <InputAdornment position="start">
                <PersonIcon />
              </InputAdornment>
            ),
          }}
        />

        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          size="small"
          label={LOCALE.login_email}
          name="email"
          value={data?.email}
          onChange={(e) => setDataProp(e, "email")}
          InputProps={{
            disabled: disabled,
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
        />

        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          size="small"
          disabled={true}
        >
          <InputLabel>{LOCALE.role}</InputLabel>
          {data && (
            <Select
              label={LOCALE.role}
              value={data?.type}
              onChange={(e) => setDataProp(e, "type")}
            >
              <MenuItem value="TEACHER">{LOCALE.teacher}</MenuItem>
              <MenuItem value="ASSOCIATE">{LOCALE.associate}</MenuItem>
            </Select>
          )}
        </FormControl>

        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          size="small"
          disabled={disabled}
        >
          <InputLabel>{LOCALE.municipality}</InputLabel>
          {municipalities && data && (
            <Select
              label={LOCALE.municipality}
              value={data?.teacher?.school?.municipality?.id}
              onChange={(e) => setDataProp(e, "municipality")}
            >
              {municipalities?.content.map((municipality) => (
                <MenuItem key={municipality.id} value={municipality.id}>
                  {municipality.name}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
        <FormControl
          variant="outlined"
          fullWidth
          margin="normal"
          size="small"
          disabled={disabled}
        >
          <InputLabel>{LOCALE.school}</InputLabel>
          {data && (
            <Select
              label={LOCALE.school}
              value={data?.teacher?.school?.id}
              onChange={(e) => setDataProp(e, "school")}
            >
              <MenuItem value={""}>None</MenuItem>
              {schools?.map((school) => (
                <MenuItem key={school.id} value={school.id}>
                  {school.name}
                </MenuItem>
              ))}
            </Select>
          )}
          <FormHelperText id="municipality-helper-text">
            {/* {errorsUser?.schoolId?.message} */}
          </FormHelperText>
        </FormControl>
        <TextField
          id="id"
          label={LOCALE.username}
          fullWidth={true}
          size="small"
          margin="normal"
          variant="outlined"
          name="username"
          value={data?.username}
          onChange={(e) => setDataProp(e, "username")}
          InputProps={{
            disabled: disabled || action != "create",
            startAdornment: (
              <InputAdornment position="start">
                <PersonIcon />
              </InputAdornment>
            ),
          }}
        />
        {action === "create" && (
          <Grid item md={12}>
            <TextField
              id="password"
              type={showPassword ? "text" : "password"}
              label={LOCALE.password}
              size="small"
              fullWidth={true}
              margin="dense"
              variant="outlined"
              name="password"
              onChange={(e) => setDataProp(e, "password")}
              InputProps={{
                disabled: disabled,
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      edge="end"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        )}
        {action === "edit" && (
          <div>
            <ExpansionPanel>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{LOCALE.user_profile_change_password}</Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <Grid container spacing={2}>
                  <Grid item xs={7}>
                    <TextField
                      id="password"
                      type={showPassword ? "text" : "password"}
                      label={LOCALE.password}
                      size="small"
                      fullWidth={true}
                      margin="normal"
                      variant="outlined"
                      name="password"
                      value={data?.password}
                      onChange={(e) => setDataProp(e, "password")}
                      InputProps={{
                        disabled: disabled,
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              onClick={handleClickShowPassword}
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Button
                      fullWidth={true}
                      style={{ verticalAlign: "middle", marginTop: "17px" }}
                      variant="contained"
                      color="secondary"
                      onClick={() => resetPassword()}
                    >
                      {LOCALE.save}
                    </Button>
                  </Grid>
                </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </div>
        )}
        <EntityMetadata data={data} />
        <DialogActions>
          {!disabled && props.form != "myProfile" && (
            <Link to={`/app/admin/users/`} style={{ textDecoration: "none" }}>
              <Button size="small" variant="outlined" color="secondary">
                {LOCALE.cancel}
              </Button>
            </Link>
          )}
          {action != "details" && (
            <Button
              type="submit"
              size="small"
              variant="contained"
              disabled={disabled}
              onClick={() => handleSubmit()}
              className={disabled ? "btn-loading" : ""}
              color="primary"
            >
              {LOCALE.save}
              {disabled && (
                <CircularProgress
                  color="secondary"
                  size={20}
                  style={{ position: "absolute" }}
                />
              )}
            </Button>
          )}
        </DialogActions>
      </div>
    </div>
  );
}
